//
// https://www.npmjs.com/package/column-resizer
//
import React, { useEffect, useRef, useState } from 'react';
import ColumnResizer from './mh-column-resizer';
import { Table } from 'react-bootstrap';

const ResizableTable = ({
  id,
  children,
  resizable,
  resizeOptions,
  ...props
}) => {
  const tableRef = useRef(null);

  const [resize, setResize] = useState();

  const enableResize = () => {
    if (!resize) {
      const resizeFn = new ColumnResizer(tableRef.current, resizeOptions);
      //const resizeFn = new ColumnResizer(tableRef.current, { ...resizeOptions, widths: [35, 35] });

      //@ts-ignore
      //tableRef.current.className = tableRef.current?.className?.replace('grip-padding', '');

      setResize(resizeFn);
    } else {
      resize.reset(resizeOptions);
    }
  };

  const disableResize = () => {
    if (!!resize) {
      resize.reset({ disable: true });
    }
  };

  useEffect(() => {
    if (tableRef.current && resizable) {
      enableResize();
    }
    // eslint-disable-off-next-line-off react-hooks/exhaustive-deps
  }, [tableRef]);

  useEffect(() => {
    return disableResize();
    // eslint-disable-off-next-line-off react-hooks/exhaustive-deps
  }, []);

  return (
    <Table id={id} {...props} ref={tableRef}>
      {children}
    </Table>
  );
};

export default ResizableTable;
